import React from 'react'

import type { IconProps } from './types'

const Cart: React.FC<IconProps> = ({
  size = 40,
  color = '#595959',
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.987.822a.833.833 0 0 0-.82.845v1.666H7.5A.833.833 0 1 0 7.5 5h1.667v1.667a.833.833 0 1 0 1.666 0V5H12.5a.833.833 0 1 0 0-1.667h-1.667V1.667a.832.832 0 0 0-.846-.845ZM2.56 1.67l-.893.008a.833.833 0 1 0 .014 1.667l.889-.008h.002L5.29 9.862a.833.833 0 0 0-.01.12l-.962 1.537c-.699 1.115.15 2.648 1.466 2.648H15a.832.832 0 1 0 0-1.667H5.784c-.092 0-.103-.018-.053-.098l.98-1.569h6.223c.605 0 1.164-.33 1.457-.857l3.428-6.17a.833.833 0 1 0-1.457-.81l-3.427 6.17h-6.13L4.11 2.695A1.672 1.672 0 0 0 2.562 1.67H2.56ZM5.833 15a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333Zm8.334 0a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333Z"
        fill={color}
      ></path>
    </svg>
  )
}

export default Cart
